import { Injectable } from '@angular/core';
import { Token } from 'src/app/manager/token';
// import { Http, Headers, ResponseContentType } from '@angular/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
// import { map } from 'rxjs/operators';
import jwt_decode from "jwt-decode";
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  isHideGebbsLogo = false;
  Token;
  // hideGebbsLogo = false;
  TokenCls: Token = new Token(this.router);
  constructor(private http: HttpClient, private router: Router) {
    // this.checkIfDomainIsForClient()
    this.hideGebbsLogo();
  }
  checkIfDomainIsForClient() {
    // const apiURL = environment.ApiUrl;
    // console.log('checkIfDomainIsForClient apiURL : ', apiURL);
    // if (apiURL === 'http://172.30.52.25:1001/') {
    //   this.hideGebbsLogo = true;
    // }
    // console.log('checkIfDomainIsForClient this.hideGebbsLogo : ',this.hideGebbsLogo);
  }
  Login(data: any) {
    return this.http.post(environment.ApiUrl + '/api/Login', data);
  }
  getQRCode(username, userId) {
    return this.http.get(environment.ApiUrl + '/api/GetPair?Username=' + username+'&userid='+userId).pipe(map(res => res));
  }

  matchOTP(data:any) {
    //return this.http.put(environment.ApiUrl + '/api/ValidatePair?pin=' + passcode + '&userid=' + userId + '&Email_Id=' + Email_Id+'&key='+key).pipe(map(res => res));
    return this.http.put(environment.ApiUrl + '/api/ValidatePair',data).pipe(map(res => res));
  }

  getTimeout() {
    return this.http.get(environment.ApiUrl + '/api/session-timeout').pipe(map(res => res));
    // session-timeout
  }

  hideGebbsLogo(){
    const ApiUrl = environment.ApiUrl;
    // if(ApiUrl == environment.iArRcmUrl){
    this.isHideGebbsLogo = false;
    // }
  }

  loginCaptcha(){
    return this.http.get(environment.ApiUrl + '/api/loginCaptcha').pipe(map(res => res));
  }

    GetClientIP(){
    return this.http.get(environment.clientInfo_clientIp).pipe(map(res => res));
  }
}
